const SITE = "https://www.mag-automate.com";

function absoluteUrl(path) {
  if (!path || path === "/") return `${SITE}/`;
  if (/^https?:\/\//i.test(path)) return path;
  return `${SITE}${path}`;
}

export function breadcrumbList(crumbs) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: crumbs.map((crumb, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: crumb.name,
      item: absoluteUrl(crumb.path),
    })),
  };
}
